import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, distinctUntilChanged, filter, map, Observable } from 'rxjs';

import { CategoryFilterState, getFilters } from '@pages/category/public_api';
import { getGridType } from '@pages/category/store/grid-type/grid-type.selectors';
import { GridTypes } from '@shared/models/grid-type.model';

@Injectable()
export class GridTypeViewService {
    public store = inject(Store);

    public getFilters$: Observable<CategoryFilterState> = this.store.select(getFilters);

    public getGridType$: Observable<GridTypes> = this.store.select(getGridType);

    public getGridTypeStore$(): Observable<GridTypes> {
        return combineLatest([
            this.getGridType$.pipe(filter(gridType => !!gridType), distinctUntilChanged((a, b) => a === b)),
            this.getFilters$.pipe(
                distinctUntilChanged((a, b) => a.isApplied === b.isApplied && a.order.isApplied === b.order.isApplied)
            ),
        ]).pipe(
            map(([gridType, filters]: [GridTypes, CategoryFilterState]) => {
                const filterApplied = filters.isApplied || filters.order.isApplied;
                if (filterApplied && gridType === GridTypes.ZARA_STUDIO) {
                    return GridTypes.GRID_4;
                }
                return gridType;
            })
        );
    }
}
